





















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import {
  ILccaActivityImperial,
  ILccaActivityMetric,
  ILccaAlternativeImperial,
  ILccaAlternativeMetric,
} from '@/modules/lcca/interfaces/lccaCalculated';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import { UnitSystem } from '@/interfaces/units';
import { lccaStore } from '@/store/store';

@Component({
  components: {
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class ActivityEditor extends Vue {
  // @Prop() alternativeIndex!: number;
  @Prop() alt!: ILccaAlternativeImperial | ILccaAlternativeMetric;

  // @PropSync('activityToEdit') activity!: ILccaActivityImperial;
  @Prop() activity!: ILccaActivityImperial | ILccaActivityMetric;

  // @PropSync('alternative') alt!: ILccaAlternative;

  sync() {
    // this.$emit('input');
  }

  get altBaseId() {
    return `alt_${this.alt.index}`;
  }

  get actId() {
    return this.activity.index;
  }

  get baseId() {
    return `${this.altBaseId}_act_${this.actId}`;
  }

  lineItemFields = [
    {
      key: 'name',
    },
    {
      key: 'units',
    },
    // {
    //   key: 'unitDescr',
    //   label: 'Description'
    // },
    {
      key: 'unitCost',
    },
    {
      key: 'quantity',
    },
    {
      key: 'total',
    },
  ];

  unitSystemIsImperial() {
    return lccaStore.displayUnits === UnitSystem.Imperial;
  }

  logClick(id: string, button: string) {
    console.log('Clicked', id, button);
  }

  addClosePeriod() {
    this.activity.laneClosePeriods.push({ start: 0, end: 0 });
  }

  deleteClosePeriod(i: number) {
    this.activity.laneClosePeriods.splice(i);
  }
}
